/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
// import axios from 'axios';
import router from "../router";
import { Toast } from "vant";
import { Message } from "element-ui";
import store from "../store";

//
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true
  });
};

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.push({ path: "/login" });
};
import axios from "axios";

const instance = axios.create({
  baseURL: "api/", // 基础路径
  withCredentials: true // 表示请求可以携带cookie
});
// instance.defaults.headers.post['Content-Type'] = 'text/plain;charset=UTF-8';
// request interceptor
instance.interceptors.request.use(
  config => {
    // let jwt = store.state.token;
    let jwt = sessionStorage.getItem("userToken");
    // console.log(jwt)
    if (null != jwt && jwt != "") {
      config.headers["Authorization"] = "Bearer " + jwt;
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      tip("登录过期，请重新登录");
      localStorage.removeItem("token");
      toLogin();
      break;
    // store.commit('loginSuccess', null);
    // setTimeout(() => {
    //   toLogin();
    // }, 1000);
    // break;
    // 404请求不存在
    case 404:
      tip("请求的资源不存在");
      break;
    case 503:
      toLogin();
      break;
    case 504:
      //   Message({
      //     message: "服务挂了" || 'Error',
      //     type: 'error',
      //     duration: 2 * 1000
      //   })
      //   tip('服务器挂了！');
      //   toLogin();
      break;
    case 700:
      toLogin();
      break;
    default:
      console.log(other);
  }
};

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
  // 请求失败
  error => {
    console.log(error);
    const { response } = error;
    console.log(response);
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      // store.commit('changeNetwork', false);
    }
  }
);

export default instance;



// WEBPACK FOOTER //
// ./src/util/basehttp.js